module.exports = __webpack_public_path__ + "static/media/webdev.c522981f.png";